module.exports = __webpack_public_path__ + "img/icon_kakao.9a8391d2.svg";